import { Assets, AnimatedSprite, Texture } from "pixi.js"
import { applyVelocity } from "../lib/apply-velocity"
import { applyFriction } from "../lib/apply-friction"
import { Pathing } from "./pathing"
import { followPath } from "../lib/follow-path"
import { useVulnerability } from "./use-vulnerability"
import { useAttackPlayer } from "./use-attack-player"

const FRAMES = 10
const FRICTION = 0.03

export async function MamaSquid({ player, isSolid, x, y }) {
  await Assets.load("res/mama-squid.json")
  const frames = [...Array(FRAMES)].map((_, i) =>
    Texture.from(`mama-squid ${i}`),
  )

  const sprite = new AnimatedSprite(frames)
  sprite.anchor.set(0.5, 0.5)
  sprite.x = x ?? 0
  sprite.y = y ?? 0
  sprite.velocity = { x: 0, y: 0 }
  sprite.animationSpeed = 0.1
  sprite.play()

  useVulnerability(sprite, {
    player,
    health: 100,
    radius: 38,
  })

  const attack = useAttackPlayer(sprite, {
    player,
    damage: 20,
    attackPoint: { x: 0.5 },
    attackRadius: 15,
  })

  const { path, tick: tickPathing } = Pathing({
    subject: sprite,
    target: player,
    isSolid,
    radius: 500,
  })

  sprite.tick = (time) => {
    if (Date.now() - sprite.lastAttack >= sprite.attackCooldown)
      followPath({ subject: sprite, path, speed: 0.03, target: player }, time)

    applyVelocity(sprite, { isSolid, time })
    applyFriction(sprite, { time, friction: FRICTION })

    sprite.animationSpeed = Math.max(
      0.05 * Math.sqrt(sprite.velocity.x ** 2 + sprite.velocity.y ** 2),
      0,
    )

    tickPathing(time)

    attack()

    if (sprite.lastHit && Date.now() - sprite.lastHit < 500) sprite.alpha = 0.5
    else sprite.alpha = 1
  }

  return sprite
}
